import CountryPageRenderer from '../components/CountryPageRenderer';
import barbadosData from '../data/country-pages/barbados';

export default function BarbadosCountryPage() {
  return <CountryPageRenderer data={barbadosData} />;
}
